// src/context/CartContext.js

import React, { createContext, useState, useEffect } from 'react';

export const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);

  // تحميل من localStorage عند أول تحميل
  useEffect(() => {
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      try {
        setCart(JSON.parse(savedCart));
      } catch (err) {
        console.error("❌ فشل في قراءة السلة:", err);
        localStorage.removeItem('cart');
      }
    }
  }, []);

  // حفظ تلقائي عند التحديث
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  // ✅ تعديل الكمية
  const updateQuantity = (index, newQuantity) => {
    setCart((prev) => {
      const updated = [...prev];
      const item = updated[index];

      item.quantity = Math.max(1, newQuantity);

      const basePrice = item.base_price;
      const optionsTotal = Object.values(item.selected_options || {})
        .flat()
        .reduce((acc, opt) => acc + (parseFloat(opt.price_diff) || 0), 0);

      item.total_price = (basePrice + optionsTotal) * item.quantity;

      return updated;
    });
  };

  const addToCart = (product) => {
    const existingIndex = cart.findIndex(
      (item) =>
        item.product_id === product.product_id &&
        JSON.stringify(item.selected_options) === JSON.stringify(product.selected_options)
    );

    if (existingIndex !== -1) {
      updateQuantity(existingIndex, cart[existingIndex].quantity + product.quantity);
    } else {
      setCart((prev) => [...prev, product]);
    }
  };

  const removeFromCart = (indexToRemove) => {
    setCart((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const clearCart = () => {
    setCart([]);
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        clearCart,
        updateQuantity, // ✅ لازم تكون موجودة عشان CartPage.js تشتغل
      }}
    >
      {children}
    </CartContext.Provider>
  );
}
